module.exports = __webpack_public_path__ + "img/Vinje_Reporter_og_fotturist.7dea768d.jpg";